import { SbBlokData, storyblokEditable as innerStoryblokEditable } from "@storyblok/react";
import { BlokBase } from "../StoryblokTypes";

/**
 * Wraps a call to @storyblok/react.storyblokEditable so we can provide custom types in StoryblokTypes.ts
 * @param blok Must inherit from BlokBase
 */
export const storyblokEditable = (blok: BlokBase) => innerStoryblokEditable(blok as unknown as SbBlokData);
